import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExportedIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.00008 0.666992C3.94999 0.666992 0.666748 3.95024 0.666748 8.00033C0.666748 12.0504 3.94999 15.3337 8.00008 15.3337C12.0502 15.3337 15.3334 12.0504 15.3334 8.00033C15.3334 3.95024 12.0502 0.666992 8.00008 0.666992ZM11.4715 6.47173C11.7318 6.21138 11.7318 5.78927 11.4715 5.52892C11.2111 5.26857 10.789 5.26857 10.5287 5.52892L7.00008 9.05752L5.47149 7.52892C5.21114 7.26857 4.78903 7.26857 4.52868 7.52892C4.26833 7.78927 4.26833 8.21138 4.52868 8.47173L6.52868 10.4717C6.78903 10.7321 7.21114 10.7321 7.47149 10.4717L11.4715 6.47173Z"
	})
});
export default SvgExportedIcon;
